module.exports = __webpack_public_path__ + "static/img/yxz.aaf7f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yxz.png
// module id = Pup2
// module chunks = 2